/**
 * Created by augustocorvalan on 8/5/14.
 */
'use strict';

const _ = require('underscore');
const tracking = require('dibs-tracking');
const get = require('lodash.get');
const Price = require('bunsen/models/inventory/Price.es');

const getPriceType = function(item, isTrade) {
    const hidingPrice = item.hidingPrice();
    const onHold = item.isOnHold();
    const isSold = item.isSold();
    const hasNetPrice = item.getPriceByType(Price.TYPE_NET);
    const isOnSale = item.getPriceByType(Price.TYPE_SALE);
    let priceType = 'list price';
    if (onHold || isSold) {
        priceType = 'N/A';
    } else if (isOnSale) {
        priceType = 'saturday sale';
    } else if (hasNetPrice && isTrade) {
        priceType = 'net price';
    } else if (hidingPrice) {
        priceType = 'price upon request';
    }
    return priceType;
};

/**
 * @module purchaseTracking
 */
const PurchaseTracking = (module.exports = function(options) {
    options = _.extend(
        {
            item: undefined,
            namespace: undefined,
            defaultCategory: undefined,
        },
        options
    );
    this._item = options.item;
    this._pageContext = options.pageContext;
    this._category = options.category;
});
PurchaseTracking.prototype = {
    /**
     * @param {Object} adds purchase context properties to trackOptions and relays to dibs-tracking.trackEvent
     */
    trackEvent: function(trackOptions, params) {
        params = params || {};
        return tracking.trackEvent(
            _.extend(
                {
                    action:
                        trackOptions.actionPrefix +
                        ' - ' +
                        this._pageContext +
                        ' ' +
                        trackOptions.objectName,
                    category: this._category,
                    label: params.label || PurchaseTracking.getLabel({ item: this._item }),
                    objectName: undefined, // name of object related to this event
                },
                trackOptions
            )
        );
    },
    trackOfferEvent: function(trackOptions) {
        return this.trackEvent(
            _.extend(
                {
                    category: 'make offer click',
                    action: this._pageContext + ' ' + trackOptions.actionSuffix,
                },
                trackOptions
            )
        );
    },
    trackPurchaseEvent: function(trackOptions, params) {
        const options = _.extend({ category: 'purchase click' }, trackOptions);
        return this.trackEvent(options, params);
    },
    trackNetPriceEvent: function(trackOptions) {
        return tracking.trackEvent(
            _.extend(
                {
                    action: 'request net price ' + trackOptions.actionSuffix,
                    category: 'request net price',
                    label: PurchaseTracking.getLabel({
                        item: this._item,
                        purchasableLabel: true,
                        pageContext: this._pageContext,
                    }),
                },
                trackOptions
            )
        );
    },
    /**
     * method version of PurchaseTracking.ecommerceAddToCartTracking
     */
    ecommerceAddToCartTracking: function(options = {}) {
        return PurchaseTracking.ecommerceAddToCartTracking(
            _.extend(
                {
                    id: this._item.get('id'),
                    name: this._item.get('title'),
                    brand: this._item.get('seller.id'),
                    price: this._item.get('pricing.totalAmount.convertedAmounts.USD'),
                    dimension76: getPriceType(this._item, options.isTrade),
                    category:
                        _.chain(this._item.get('classification.inflatedCategories'))
                            .last()
                            .pluck('label')
                            .value()
                            .join('/') || undefined,
                },
                options
            )
        );
    },
};
_.extend(PurchaseTracking, {
    // static methods
    /**
     * @param {Object} options
     */
    getLabel: function(options) {
        options = _.extend(
            {
                item: undefined,
                purchasableLabel: undefined,
                pageContext: undefined,
            },
            options
        );

        const item = options.item;
        const labelInfo = options.labelInfo || {};

        if (item) {
            const isNegotiablePrice = get(item, 'pricing.negotiable') || item.isNegotiablePrice();
            const acceptReturnPolicy =
                get(item, 'returnPolicy.accept') || item.get('returnPolicy.accept');
            if (options.purchasableLabel) {
                labelInfo.pur = item.canMakePurchase();
            }

            // MCPERSON-1391/1392: For request net price on the pdp, analytics wants the neg flag logic
            // to resemble the logic used for the same flag in the GA productStatus custom dimension.
            // It uses the logic in models/inventory/Item.php#canMakeOffer so PUR items are always categorized as not negotiable.
            // With this pageContext condition, PUR items will have a value of neg='n' on the pdp,
            // but can have a value of neg='y' in mc (this currently happens on the acceptOffer button for PUR items).
            // Eventually when buyers can make offers on the pdp on PUR items, this page context condition can be removed.
            labelInfo.neg =
                options.pageContext === 'pdp' ? item.canMakeBuyerOffer() : isNegotiablePrice;
            labelInfo.ship = get(item, 'shipmentPrice')
                ? get(item, 'shipmentPrice.value')
                : !!_.chain(item.get('shipmentQuotes'))
                      .result('first')
                      .result('getAmountCurrencies')
                      .value();
            // if this happens to be a graphql response, 'returnPolicy.accept' is a boolean
            labelInfo.ret = acceptReturnPolicy === true || acceptReturnPolicy === 'Y';
        }

        return _.map(labelInfo, function(result, label) {
            return [label, result ? 'y' : 'n'].join('=');
        }).join('|');
    },
    /**
     * @param {Object} item
     * @param {String} category
     * @param {String} action
     */
    firePurchaseButtonTracking: function(item, category, action, params) {
        return new PurchaseTracking({ item: item }).trackPurchaseEvent({ action: action }, params);
    },

    /**
     * @param {Object} options
     * @param {String} url
     * @param {String} dealerPk
     * @param {String} price
     */
    //                                   (url, dealerPk, price) { // legacy form
    ecommerceAddToCartTracking: function(options) {
        if ('string' === typeof options) {
            options = {
                url: arguments[0],
                brand: arguments[1],
                price: arguments[2],
            };
        } else {
            options = _.extend(
                {
                    url: undefined,
                    dealerPk: undefined,
                    price: undefined,
                },
                options
            );
        }
        tracking.trackEcommerce({
            type: 'addToCart',
            products: [
                _.pick(options, 'url', 'price', 'id', 'name', 'category', 'dimension76', 'brand'),
            ],
        });
    },
});



// WEBPACK FOOTER //
// ./assets/js/global/mixins/purchaseTracking.es.js